import { render, staticRenderFns } from "./zcDetails.vue?vue&type=template&id=613046a6&scoped=true&"
import script from "./zcDetails.vue?vue&type=script&lang=js&"
export * from "./zcDetails.vue?vue&type=script&lang=js&"
import style0 from "./zcDetails.vue?vue&type=style&index=0&id=613046a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613046a6",
  null
  
)

export default component.exports